import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import Loader from 'components/layout/Loader';
import Breadcrumb from 'components/layout/Breadcrumb';

import Data from 'components/Data';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class Integrations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showKey: false,
    };
  }

  render() {
    const { intl, appIntl, data } = this.props;
    const messages = intl.messages;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.integrations)}>
        <div class="container-fluid padding-25 sm-padding-10">
          <Data dataName="myAppKey" url={'/api/myappkey.json'} data={data} />

          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
              { link: null, name: messages.integrations },
            ]}
            className="p-t-0"
          />

          {data.pending ? (
            <Loader />
          ) : (
            <Grid fluid>
              <Row>
                <Col>
                  <h1>Creacheck integrations</h1>
                  <p>
                    Looking for possibilities to integrate your software with Creacheck? Here you can find your API key
                    and some instructions how to do so.
                  </p>
                </Col>
              </Row>

              <Row>
                <Col>
                  <h2>Your api key</h2>

                  <div class="panel b-rad-lg">
                    <div class="panel-body">
                      {this.state.showKey ? (
                        <span>{data.data}</span>
                      ) : (
                        <div>
                          <span>API key is hidden</span>
                          <Button class="m-l-10" bsSize="sm" onClick={() => this.setState({ showKey: true })}>
                            <i class="fa fa-eye" /> Show API key
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <h2>API documentation</h2>
                </Col>
              </Row>

              <Row>
                <Col>
                  You can find the documentation for our API by following this link:{' '}
                  <Link to={appIntl.urlPrefix + 'docs'}>API documentation</Link>
                </Col>
              </Row>
            </Grid>
          )}
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
    data: state.data.myAppKey,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Integrations)));
